module.exports = __webpack_public_path__ + "static/image-large-5912d13cfcb64efc03c422474e4b62d7.jpg";